import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { push } from 'react-router-redux'
import { injectIntl } from 'react-intl'

import Activities from './menu/Activities'
import QuestMenuItem from './menu/QuestMenuItem'

import {
  isOtherInformationComplete,
  isBasicInformationComplete,
  areImagesComplete
} from '../../utils/quest'
import { getReviewStatus } from '../../utils/review'
import { messages } from '../../utils/messages/label'
import { activitiesMessage } from '../../utils/messages'

class Menu extends PureComponent {
  constructor(props) {
    super(props)
    this.onClickBound = this.onClick.bind(this)
  }

  render() {
    const { quest, intl, activities } = this.props

    const basicInfoLabel = intl.formatMessage(messages.basicInfo)
    const topicsAndStandardsLabel = intl.formatMessage(
      messages.topicsAndStandards
    )
    const imagesLabel = intl.formatMessage(messages.images)
    const otherInformationLabel = intl.formatMessage(messages.otherInfo)
    const questReviewLabel = intl.formatMessage(messages.questReview)

    return (
      <div className="quest-menu">
        <ul>
          <QuestMenuItem
            layout="basicinformation"
            text={basicInfoLabel}
            isComplete={isBasicInformationComplete(quest)}
          />

          <QuestMenuItem layout="skills" text="Skills" />

          <QuestMenuItem
            layout="topicsandstandards"
            text={topicsAndStandardsLabel}
          />

          <li
            data-layout="activities"
            id="activitiesMenuItem"
            onClick={this.onClickBound}
          >
            <div className="label-container">
              <label>{activitiesMessage}</label>
              <div className="requiredtool" />
            </div>
          </li>
          {activities.length > 0 && (
            <li
              data-layout="activities"
              className="activities-menu-container parent"
            >
              <Activities activities={activities} />
            </li>
          )}

          <QuestMenuItem
            layout="images"
            text="Image"
            isComplete={areImagesComplete(quest)}
          />
          <QuestMenuItem
            layout="otherinformation"
            text={otherInformationLabel}
            isComplete={isOtherInformationComplete(quest)}
          />
          <div className="line" />
          <QuestMenuItem
            layout="questreview"
            text={questReviewLabel}
            reviewStatus={getReviewStatus(quest)}
          />
          <QuestMenuItem layout="questhistory" text="Quest History" />
        </ul>
      </div>
    )
  }

  onClick() {
    const { dispatch, quest, activities } = this.props
    if (activities.length > 0) {
      // quick and dirty way to default to the first activity when "Activities" header is clicked
      const firstActivityId = activities[0].id
      document.getElementById(firstActivityId).click()
    } else {
      // handling no activities when Activities menu item clicked
      dispatch(push(`/quest/${quest.id}/activities`))
    }
  }
}

Menu.propTypes = {
  quest: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  activities: PropTypes.array.isRequired
}

export default injectIntl(Menu)



// WEBPACK FOOTER //
// ./src/components/quest/Menu.js